module.exports = __webpack_public_path__ + "img/max-envelope-sync.6f448225.svg";